export const INPUT_CHAR_LIMIT = 256;
export const TEXTAREA_CHAR_LIMIT = 5000;
